import { createContext } from 'react';

/** Native form association survives when its commands portal into an island. */
export const WorkspaceActionFormContext = createContext<string | undefined>(undefined);
